import React from "react"

import { PRODUCT_IMAGES } from "../../../../../../utils/imagesMap"

import CoreUpsellComponent from "./coreproduct-upsell"

export const DESCRIPTION = `A healthy scalp is essential for hair growth. Pair our 2-in-1 shampoo and conditioner with Nutrafol Men to promote scalp health so hair can grow and thrive.`
export const UPSELL_SOURCE = `mens_core_active_cleanse_upgrade_modal`
export const UPSELL_NAME = `Men's Core + Active Cleanse Upgrade Modal`

export const UPSELL_ITEM_PROPS = {
  core_category: "Men",
  image: { url: PRODUCT_IMAGES.ACTIVECLEANSE.label2 },
  info: "Scalp Care",
  name: "2-in-1 Shampoo & Conditioner",
  old_price: 44,
  price: 39,
  product_category: "Scalp Support",
  product_gender: "Men",
  purchase_type: "Single Purchase",
  sku: "ACTIVECLEANSE-N01",
}

export const UPSELL_COMBO_PROPS = {
  billing_interval: "1 month",
  core_category: "Multi-Category Kits",
  image: { url: PRODUCT_IMAGES.MENX1.label1 },
  name: "Men + 2-in-1 Shampoo and Conditioner",
  old_price: 132,
  price: 118,
  product_category: "Multi-Category Kits",
  product_gender: "Men",
  purchase_type: "Growthplan 1",
  sku: "MENX1-S01",
  shipping_interval: "1 month",
  subscription_type: "Monthly",
}

export const UPSELL_PROPS_VARIANT = {
  UPSELL_NAME,
  UPSELL_ITEM_PROPS,
  UPSELL_COMBO_PROPS,
  UPSELL_SOURCE,
}

const CoreUpsellVariant = ({ upsellOption }) => {
  return (
    <CoreUpsellComponent
      upsellOption={upsellOption}
      UPSELL_COMBO_PROPS={UPSELL_COMBO_PROPS}
      UPSELL_ITEM_PROPS={UPSELL_ITEM_PROPS}
      UPSELL_SOURCE={UPSELL_SOURCE}
      DESCRIPTION={DESCRIPTION}
    />
  )
}

export default CoreUpsellVariant
